/**
 * 创建websoket
 **/
import Tool from '@/assets/js/utils.js'
import $store from '@/store.js'
import SocketApi from '@/assets/js/websocket'
const session = Tool.getSession()
const protocol = document.location.protocol === 'https:' ? 'wss://' : 'ws://' // 获取协议
export const createWebsocket = {
  pageRequest (type, key) {
    const dataRequest = {
      url: `${protocol + $store.state.common.baseUrl.wsBaseUrl}/pageRequest?token=${session}&taskId=${Tool.return32Str()}_q`,
      sendHeart: true
    }
    // 初始化

    if (type == 'off') {
      this.pageRequests.off() // 关闭
    } else if (type == 'stop') {
      this.pageRequests.stop(key)
    } else if ($store.state.common.baseUrl.wsBaseUrl && session) { // 如果获取到url 并且获取到session之后才可以创建websocket
      this.pageRequests = new SocketApi(dataRequest)
      this.pageRequests.init()
    }
    $store.state.websocket.pageRequest = this.pageRequests
  },
  // 行为动作同步
  BehaviorWebsocket (businessId, type) {
    const success = (e) => {
      console.log(e)
    }
    const dataRequest = {
      url: `${protocol + $store.state.common.baseUrl.wsBaseUrl}/pageSerBusRequest?token=${session}&taskId=${Tool.return32Str()}_q&businessId=${businessId}`,
      key: 'etanTest',
      success
    }
    // 初始化

    if (type == 'off') {
      this.BehaviorWebsockets.off() // 关闭
    } else if (type == 'stop') {
      this.BehaviorWebsockets.stop(key)
    } else if ($store.state.common.baseUrl.wsBaseUrl && session) { // 如果获取到url 并且获取到session之后才可以创建websocket
      this.BehaviorWebsockets = new SocketApi(dataRequest)
      this.BehaviorWebsockets.init()
    }
    $store.state.websocket.BehaviorWebsocket = this.BehaviorWebsockets
  },
  // 新加websocket  scte中setting部分用到
  pageSerBusRequest (type, key) {
    const dataRequest = {
      url: `${protocol + $store.state.common.baseUrl.wsBaseUrl}/pageSerBusRequest?token=${session}&taskId=${Tool.return32Str()}_q&businessId=${Tool.return32Str()}`,
      sendHeart: true
    }
    // 初始化

    if (type == 'off') {
      this.pageSerBusRequests.off() // 关闭
    } else if (type == 'stop') {
      this.pageSerBusRequests.stop(key)
    } else if ($store.state.common.baseUrl.wsBaseUrl && session) { // 如果获取到url 并且获取到session之后才可以创建websocket
      this.pageSerBusRequests = new SocketApi(dataRequest)
      this.pageSerBusRequests.init()
    }
    $store.state.websocket.pageSerBusRequest = this.pageSerBusRequests
  },
  // 新的websocket用来获取R的信息
  pageRWebsocket (type, key, needSendHeart) {
    const dataRequest = {
      url: `${protocol + $store.state.common.baseUrl.wsBaseUrl}/pageRWebsocket?token=${session}&taskId=${Tool.return32Str()}_q`,
      sendHeart: true
    }
    if (type == 'off') {
      this.pageRWebsockets.off() // 关闭
    } else if (type == 'stop') {
      this.pageRWebsockets.stop(key)
    } else if ($store.state.common.baseUrl.wsBaseUrl && session) { // 如果获取到url 并且获取到session之后才可以创建websocket
      this.pageRWebsockets = new SocketApi(dataRequest)
      this.pageRWebsockets.init()
    }
    $store.state.websocket.pageRWebsocket = this.pageRWebsockets
  },
  pageWebsocket (type, key, selectRid) {
    const rid = selectRid || $store.state.selectRId
    const dataWebsocket = {
      url: `${protocol + $store.state.common.baseUrl.wsBaseUrl}/pageWebsocket?rid=${rid}&taskId=${Tool.return32Str()}_q`
    }
    // 初始化
    if (type == 'off') {
      this.pageWebsockets.off() // 关闭
    } else if (type == 'stop') {
      this.pageWebsockets.stop(key)
    } else {
      this.pageWebsockets = new SocketApi(dataWebsocket)
      this.pageWebsockets.init()
    }

    $store.state.websocket.pageWebsocket = this.pageWebsockets
  },
  deviceChange (type, key) {
    const dataWebsocket = {
      url: `${protocol + $store.state.common.baseUrl.wsBaseUrl}/deviceChange?taskId=${Tool.return32Str()}_q`
    }
    // 初始化
    if (type == 'off') {
      this.deviceChanges.off() // 关闭
    } else if (type == 'stop') {
      this.deviceChanges.stop(key)
    } else {
      this.deviceChanges = new SocketApi(dataWebsocket)
      this.deviceChanges.init()
    }
    $store.state.websocket.deviceChange = this.deviceChanges
  },
  pageAnyWheresocket (type, key, peerId) {
    const dataWebsocket = {
      // ws://cc-ms-dev.tvunetworks.com/ws/anywhere/ef8c90df6a510ac7
      url: `${protocol + $store.state.common.baseUrl.wsBaseUrl}/anywhere/${peerId}?math=${Math.random()}`
    }
    // 初始化
    if (type == 'off') {
      this.pageAnyWheresockets.off() // 关闭
    } else if (type == 'stop') {
      this.pageAnyWheresockets.stop(key)
    } else {
      this.pageAnyWheresockets = new SocketApi(dataWebsocket)
      this.pageAnyWheresockets.init()
    }
    const newWebsocket = $store.state.websocket
    newWebsocket.pageAnyWheresocket = this.pageAnyWheresockets
    $store.commit('websocket', newWebsocket)
  }
}
export default {
  install (vm) {
    vm.prototype.$createWebsocket = createWebsocket
  }
}
